<script setup>
import { computed, ref } from "vue";

const props = defineProps({
    modelValue: {
        type: String,
        required: true,
    },
    // [{ value: "recent", label: "Most Recent" }, …]
    options: {
        type: Array,
        required: true,
    },
});

const emit = defineEmits(["update:modelValue"]);

const open = ref(false);

const current = computed(() =>
    props.options.find((option) => option.value === props.modelValue),
);

function close() {
    open.value = false;
}

function select(option) {
    emit("update:modelValue", option.value);
    close();
}
</script>

<template>
    <div v-click-outside="close" class="relative">
        <button
            type="button"
            class="flex w-full items-center justify-between gap-6 whitespace-nowrap rounded-brand border border-solid border-[#dad9d2] bg-white px-5 py-3.5 font-brand text-[16px] font-semibold text-[#191e3e] lg:w-auto lg:min-w-[306px]"
            @click="open = !open"
        >
            Sorted by {{ current?.label }}
            <svg
                viewBox="0 0 14 12"
                class="h-2.5 w-3 shrink-0 text-brand-red transition-transform"
                :class="{ 'rotate-180': open }"
                fill="currentColor"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linejoin="round"
                aria-hidden="true"
            >
                <path d="M3 3 L11 3 L7 9.5 Z" />
            </svg>
        </button>

        <div
            v-show="open"
            class="absolute right-0 z-20 mt-2 w-full overflow-hidden rounded-brand bg-white shadow-brand-hero ring-1 ring-black/5"
        >
            <button
                v-for="option in options"
                :key="option.value"
                type="button"
                class="block w-full px-5 py-3 text-left font-brand text-[15px] text-[#102a3d] transition hover:bg-brand-cream/60"
                :class="{ 'font-semibold': option.value === modelValue }"
                @click="select(option)"
            >
                {{ option.label }}
            </button>
        </div>
    </div>
</template>
